<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import {jsPDF} from 'jspdf';
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import pdf from 'vue-pdf';
import Multiselect from 'vue-multiselect';
import * as XLSX from "xlsx";

export default {
    components: { Layout, PageHeader, DatePicker, pdf, Multiselect },
    data() {
        return {
            isLoading: false,
            isInitialLoading: true,
            isLoadingHistorial: false,
            title: "Historial gastos",
            items: [
                {
                text: "Reembolsos",
                href: "/"
                },
                {
                text: "Historial gastos",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            direccion:'',
            desde:'',
            hasta:'',
            extension:'',
            previewObjectUrl: '',
            archivoDisponible: true,
            archivoMensaje: '',
            mostrarDescargaPorTipo: false,
            tipoGastoSeleccionado: '',
            tipoGastoDescargaSeleccionado: '',
            estadoPagoSeleccionado: 'todos',
            fechaRendicionDesde: '',
            fechaRendicionHasta: '',
            coordinadorSeleccionado: [],
            sedeSeleccionada: '',
            updatingPagoEventoIds: {},
            expandedEventoId: null,
        };
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        coordinadoresSeleccionadosFiltrables() {
            const coordinadores = Array.isArray(this.coordinadorSeleccionado)
                ? this.coordinadorSeleccionado
                : [this.coordinadorSeleccionado];

            return [...new Set(coordinadores.map((item) => (item || '').trim()).filter((item) => item !== ''))];
        },
        filteredDataBase() {
            const filtro = (this.filtro || '').toLowerCase().trim();
            return this.reembolsos
                .map((item) => {
                    if (this.coordinadoresSeleccionadosFiltrables.length > 0 && !this.coordinadoresSeleccionadosFiltrables.includes((item.coordinador_evento || '').trim())) {
                        return null;
                    }

                    if (this.sedeSeleccionada && (item.sede_asociada || '').trim() !== this.sedeSeleccionada) {
                        return null;
                    }

                    const gastosFiltrados = (item.gastos || []).filter((gasto) => {
                        if (!this.isFechaRendicionDentroRango(gasto)) {
                            return false;
                        }

                        if (this.estadoPagoSeleccionado === 'pagados' && !gasto.pagado_historial) {
                            return false;
                        }

                        if (this.estadoPagoSeleccionado === 'no_pagados' && gasto.pagado_historial) {
                            return false;
                        }

                        return true;
                    });

                    if (!gastosFiltrados.length) {
                        return null;
                    }

                    const textoBusqueda = [
                        item.codigo,
                        item.nombre_difusion,
                        item.coordinador_evento,
                        item.rbd_colegio,
                        item.sede_asociada,
                        item.colegio,
                        ...gastosFiltrados.map((gasto) => gasto.tipo_gasto),
                    ].join(' ').toLowerCase();

                    if (filtro && !textoBusqueda.includes(filtro)) {
                        return null;
                    }

                    const pagadoHistorial = gastosFiltrados.every((gasto) => !!gasto.pagado_historial);
                    const fechasMarcado = gastosFiltrados
                        .map((gasto) => gasto.pagado_historial_at)
                        .filter((fecha) => !!fecha)
                        .sort()
                        .reverse();

                    return {
                        ...item,
                        gastos: gastosFiltrados,
                        total_comprobantes: gastosFiltrados.length,
                        monto_total: gastosFiltrados.reduce((acumulado, gasto) => acumulado + this.normalizeMonto(gasto.monto), 0),
                        pagado_historial: pagadoHistorial,
                        pagado_historial_at: pagadoHistorial ? (fechasMarcado[0] || null) : null,
                    };
                })
                .filter((item) => !!item);
        },
        filteredData() {
            if (!this.tipoGastoSeleccionado) {
                return this.filteredDataBase;
            }

            return this.filteredDataBase
                .map((item) => {
                    const gastosFiltrados = (item.gastos || []).filter((gasto) => gasto.tipo_gasto === this.tipoGastoSeleccionado);

                    if (!gastosFiltrados.length) {
                        return null;
                    }

                    const pagadoHistorial = gastosFiltrados.every((gasto) => !!gasto.pagado_historial);
                    const fechasMarcado = gastosFiltrados
                        .map((gasto) => gasto.pagado_historial_at)
                        .filter((fecha) => !!fecha)
                        .sort()
                        .reverse();

                    return {
                        ...item,
                        gastos: gastosFiltrados,
                        total_comprobantes: gastosFiltrados.length,
                        monto_total: gastosFiltrados.reduce((acumulado, gasto) => acumulado + this.normalizeMonto(gasto.monto), 0),
                        pagado_historial: pagadoHistorial,
                        pagado_historial_at: pagadoHistorial ? (fechasMarcado[0] || null) : null,
                    };
                })
                .filter((item) => !!item);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
        tiposGastoDisponibles() {
            const tipos = new Set();
            this.filteredDataBase.forEach((evento) => {
                (evento.gastos || []).forEach((gasto) => {
                    if (gasto && gasto.tipo_gasto) {
                        tipos.add(gasto.tipo_gasto);
                    }
                });
            });

            return [
                { value: '', text: 'Seleccionar tipo de gasto' },
                ...Array.from(tipos)
                    .sort((a, b) => a.localeCompare(b, 'es'))
                    .map((tipo) => ({ value: tipo, text: tipo }))
            ];
        },
        coordinadoresDisponibles() {
            return [...new Set(
                (this.reembolsos || [])
                    .map((item) => (item.coordinador_evento || '').trim())
                    .filter((item) => item !== '')
            )].sort((a, b) => a.localeCompare(b, 'es'));
        },
        sedesDisponibles() {
            const sedes = [...new Set(
                (this.reembolsos || [])
                    .map((item) => (item.sede_asociada || '').trim())
                    .filter((item) => item !== '')
            )].sort((a, b) => a.localeCompare(b, 'es'));

            return [
                { value: '', text: 'Todas las sedes' },
                ...sedes.map((sede) => ({ value: sede, text: sede })),
            ];
        },
        anyDownloadInProgress() {
            return Object.values(this.downloadStates || {}).some((state) => !!state);
        },
        gastosFiltradosConEvento() {
            return this.filteredData.flatMap((evento) => {
                return (evento.gastos || []).map((gasto) => ({ evento, gasto }));
            });
        },
        comprobantesFiltradosCount() {
            return this.gastosFiltradosConEvento.length;
        },
        montoTotalFiltrado() {
            return this.gastosFiltradosConEvento.reduce((acumulado, item) => acumulado + this.normalizeMonto(item.gasto.monto), 0);
        },
        totalPendientesPago() {
            return this.gastosFiltradosConEvento.filter((item) => !item.gasto.pagado_historial).length;
        },
        rangoFechasLabel() {
            if (!this.desde || !this.hasta) {
                return 'Sin rango seleccionado';
            }

            return `${moment(this.desde).format('DD-MM-YYYY')} al ${moment(this.hasta).format('DD-MM-YYYY')}`;
        },
        estadoPagoOptions() {
            return [
                { value: 'todos', text: 'Todos los estados de rendicion' },
                { value: 'pagados', text: 'Solo rendidos' },
                { value: 'no_pagados', text: 'Solo no rendidos' },
            ];
        },
        eventosVisiblesIds() {
            return this.filteredData.map((item) => item.id).filter((id) => !!id);
        },
        puedeGestionarPagos() {
            return !!(this.user && this.user.rol !== 'Coordinador');
        },
    },
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        tipoGastoSeleccionado() {
            this.currentPage = 1;
        },
        coordinadorSeleccionado() {
            this.currentPage = 1;
        },
        sedeSeleccionada() {
            this.currentPage = 1;
        },
        estadoPagoSeleccionado() {
            this.currentPage = 1;
        },
        fechaRendicionDesde(valor) {
            this.currentPage = 1;
            this.fechaRendicionHasta = valor || '';
        },
        fechaRendicionHasta() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        },
    },
    methods:{
        resumenColegio(nombreColegio) {
            const nombre = String(nombreColegio || '').trim();

            if (!nombre) {
                return '-';
            }

            return nombre.length > 26 ? `${nombre.slice(0, 26).trim()}...` : nombre;
        },
        tituloColegio(nombreColegio) {
            const nombre = String(nombreColegio || '').trim();
            return nombre || 'Sin colegio';
        },
        ver_mas(item){
            if (!item || !item.id) {
                return;
            }

            if (this.expandedEventoId === item.id) {
                this.expandedEventoId = null;
            }
        },
        labelVerMas(item) {
            return this.expandedEventoId === item.id ? 'Ver menos' : 'Ver más';
        },
        onEventoExpanded(eventoId) {
            this.expandedEventoId = eventoId;
        },
        onEventoCollapsed(eventoId) {
            if (this.expandedEventoId === eventoId) {
                this.expandedEventoId = null;
            }
        },
        resetExpensePreview() {
            if (this.previewObjectUrl) {
                URL.revokeObjectURL(this.previewObjectUrl);
            }
            this.previewObjectUrl = '';
            this.direccion = '';
            this.extension = '';
            this.archivoDisponible = true;
            this.archivoMensaje = '';
        },
        isProtectedExpenseUrl(url) {
            return typeof url === 'string' && url.startsWith('/api/gasto_archivo/');
        },
        async resolveProtectedExpenseUrl(fileUrl) {
            try {
                const response = await axios.get(fileUrl, {
                    responseType: 'blob',
                    validateStatus: () => true,
                });

                if (response.status >= 200 && response.status < 300) {
                    this.previewObjectUrl = URL.createObjectURL(response.data);
                    return {
                        disponible: true,
                        url: this.previewObjectUrl,
                    };
                }

                let mensaje = 'No se pudo cargar el comprobante.';
                try {
                    const rawText = response.data instanceof Blob ? await response.data.text() : '';
                    const parsed = rawText ? JSON.parse(rawText) : null;
                    mensaje = parsed && parsed.mensaje ? parsed.mensaje : mensaje;
                } catch (error) {
                    mensaje = response.status === 403
                        ? 'No autorizado'
                        : mensaje;
                }

                return {
                    disponible: false,
                    mensaje,
                };
            } catch (error) {
                const mensaje = error && error.response && error.response.data && error.response.data.mensaje
                    ? error.response.data.mensaje
                    : 'No se pudo cargar el comprobante.';

                return {
                    disponible: false,
                    mensaje,
                };
            }
        },
        prepareExpensePreview(item) {
            this.resetExpensePreview();

            if (!item) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El gasto no tiene comprobante asociado.';
                return;
            }

            const fileUrl = item.comprobante_local_disponible === false && item.imagen_url_respaldo
                ? item.imagen_url_respaldo
                : (item.imagen_url || item.imagen_url_respaldo || '');

            if (!fileUrl) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El comprobante no está disponible ni localmente ni en S3.';
                return;
            }

            const extension = (fileUrl.split('.').pop() || '').toLowerCase();
            this.extension = extension === 'pdf' ? 'pdf' : 'img';

            if (this.isProtectedExpenseUrl(fileUrl)) {
                return this.resolveProtectedExpenseUrl(fileUrl).then((resultado) => {
                    this.archivoDisponible = resultado.disponible;
                    this.archivoMensaje = resultado.mensaje || '';
                    this.direccion = resultado.url || '';
                });
            }

            this.direccion = fileUrl;
            return Promise.resolve();
        },
        async ver_comprobante(item){
            await this.prepareExpensePreview(item);
            this.$refs['modal-imagen'].show();
        },
        async generarPDF(item1, item2) {
            return this.runDownload('gasto_' + item2.id, async () => {
                this.isLoading = true;
                try {
                    const doc = new jsPDF();
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(12);
                    doc.text("Evento: " + item1.codigo, 20, 16);
                    doc.text("Fecha: " + item2.fecha, 20, 26);
                    doc.text("Monto: " + item2.monto, 20, 36);
                    if (item2.imagen_url) {
                        try {
                            const extension = item2.imagen_url.split('.').pop().toLowerCase();

                            if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                                const base64 = await this.convertirImagenABase64(item2.imagen_url);
                                doc.addImage(base64, "PNG", 20, 48, 100, 100);
                            } else if (extension === "pdf") {
                                const response = await fetch(item2.imagen_url);
                                const blob = await response.blob();
                                const pdfUrl = URL.createObjectURL(blob);

                                const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                                const page = await pdfDoc.getPage(1);
                                const viewport = page.getViewport({ scale: 1 });

                                const canvas = document.createElement("canvas");
                                const context = canvas.getContext("2d");
                                canvas.width = viewport.width;
                                canvas.height = viewport.height;

                                await page.render({ canvasContext: context, viewport }).promise;

                                const pdfImage = canvas.toDataURL("image/png");
                                doc.addImage(pdfImage, "PNG", 20, 48, 150, 200);
                            }
                        } catch (error) {
                            console.error("Error al cargar la imagen o PDF:", error);
                        }
                    }
                    doc.save("documento.pdf");
                    try {
                        await axios.get(`/api/descarga_gasto/${item2.id}`);
                        this.mostrarmes();
                    } catch (error) {
                        console.error("Error al registrar la descarga:", error);
                    }
                } finally {
                    this.isLoading = false;
                }
            }, {
                message: 'Se esta preparando el comprobante. Esto puede tardar unos segundos.'
            });
        },
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();
            let fechaInicio, fechaFin;
            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        mostrarmes(options = false){
            const config = typeof options === 'boolean'
                ? { esCargaInicial: options, preservePage: false }
                : {
                    esCargaInicial: false,
                    preservePage: false,
                    ...(options || {}),
                };

            const paginaActual = this.currentPage;

            if (config.esCargaInicial) {
                this.isInitialLoading = true;
            }

            this.isLoadingHistorial = true;
            this.isLoading = true;
            axios.get('/api/gastos_aprobados/' + this.desde + '/' + this.hasta, {
                params: {
                    fecha_rendicion_desde: this.fechaRendicionDesde || null,
                    fecha_rendicion_hasta: this.fechaRendicionHasta || null,
                    sede: this.sedeSeleccionada || null,
                }
            }).then(response => {
                this.reembolsos= response.data.reembolsos.filter((us) => us.boolean==true);
                const totalPages = Math.max(1, Math.ceil(this.filteredData.length / this.perPage) || 1);
                this.currentPage = config.preservePage ? Math.min(paginaActual, totalPages) : 1;
            }).finally(() => {
                this.isLoading = false;
                this.isLoadingHistorial = false;
                if (config.esCargaInicial) {
                    this.isInitialLoading = false;
                }
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        formatFechaHora(fechaHora) {
            if (!fechaHora) {
                return '';
            }

            return moment(fechaHora).format('DD-MM-YYYY HH:mm');
        },
        normalizarFechaSoloDia(valor) {
            if (!valor) {
                return '';
            }

            const fecha = moment(valor);
            return fecha.isValid() ? fecha.format('YYYY-MM-DD') : '';
        },
        isFechaRendicionDentroRango(gasto) {
            const desde = this.normalizarFechaSoloDia(this.fechaRendicionDesde);
            const hasta = this.normalizarFechaSoloDia(this.fechaRendicionHasta);

            if (!desde && !hasta) {
                return true;
            }

            const fechaRendicion = this.normalizarFechaSoloDia(gasto && gasto.pagado_historial_at);
            if (!fechaRendicion) {
                return false;
            }

            if (desde && fechaRendicion < desde) {
                return false;
            }

            if (hasta && fechaRendicion > hasta) {
                return false;
            }

            return true;
        },
        normalizeMonto(valor) {
            return parseInt((valor || 0).toString().replace(/[^0-9\-]/g, ''), 10) || 0;
        },
        formatMonto(valor) {
            const numero = this.normalizeMonto(valor);
            return numero.toLocaleString('es-CL');
        },
        limpiarFiltros() {
            this.coordinadorSeleccionado = [];
            this.sedeSeleccionada = '';
            this.tipoGastoSeleccionado = '';
            this.tipoGastoDescargaSeleccionado = '';
            this.estadoPagoSeleccionado = 'todos';
            this.fechaRendicionDesde = '';
            this.fechaRendicionHasta = '';
            this.filtro = '';
        },
        isUpdatingPagoEvento(eventoId) {
            return !!this.updatingPagoEventoIds[eventoId];
        },
        actualizarEstadoPagadoLocal(eventoIds, pagado, pagadoHistorialAt, tipoGasto = null) {
            const ids = new Set(
                (Array.isArray(eventoIds) ? eventoIds : [eventoIds])
                    .filter((id) => !!id)
                    .map((id) => Number(id))
            );

            if (!ids.size) {
                return;
            }

            this.reembolsos = (this.reembolsos || []).map((evento) => {
                if (!ids.has(Number(evento.id))) {
                    return evento;
                }

                return {
                    ...evento,
                    gastos: (evento.gastos || []).map((gasto) => {
                        if (tipoGasto && gasto.tipo_gasto !== tipoGasto) {
                            return gasto;
                        }

                        return {
                            ...gasto,
                            pagado_historial: pagado,
                            pagado_historial_at: pagado ? pagadoHistorialAt : null,
                        };
                    }),
                };
            });
        },
        marcarPagadoEvento(item, marcado) {
            if (!this.puedeGestionarPagos) {
                return;
            }

            if (!item || !item.id) {
                return;
            }

            if (!item.permite_marcar_pagado || this.isUpdatingPagoEvento(item.id)) {
                return;
            }

            this.$set(this.updatingPagoEventoIds, item.id, true);

            axios.post('/api/marcar_gastos_pagados', {
                evento_id: item.id,
                desde: this.desde,
                hasta: this.hasta,
                pagado: marcado,
                tipo_gasto: this.tipoGastoSeleccionado || null,
            }).then((response) => {
                if (response.data && response.data.estado) {
                    this.actualizarEstadoPagadoLocal(
                        item.id,
                        !!response.data.pagado_historial,
                        response.data.pagado_historial_at || null,
                        this.tipoGastoSeleccionado || null
                    );
                    this.mostrarmes({ preservePage: true });
                    return;
                }

                throw new Error((response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo actualizar el estado de rendicion');
            }).catch((error) => {
                const mensaje = error?.response?.data?.mensaje || error?.message || 'No se pudo actualizar el estado de rendicion';
                this.$set(item, 'pagado_historial', !marcado);
                Swal.fire({
                    icon: 'error',
                    title: mensaje,
                    timer: 3200,
                    showConfirmButton: false,
                });
            }).finally(() => {
                this.$set(this.updatingPagoEventoIds, item.id, false);
            });
        },
        marcarPagadosVisibles() {
            if (!this.puedeGestionarPagos) {
                return;
            }

            if (!this.eventosVisiblesIds.length || !this.totalPendientesPago) {
                return;
            }

            Swal.fire({
                icon: 'question',
                title: 'Marcar comprobantes visibles como rendidos',
                text: `Se marcarán ${this.totalPendientesPago} comprobante(s) visibles del rango ${this.rangoFechasLabel} como rendidos.`,
                showCancelButton: true,
                confirmButtonText: 'Sí, marcar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                this.isLoading = true;
                axios.post('/api/marcar_gastos_pagados', {
                    evento_ids: this.eventosVisiblesIds,
                    desde: this.desde,
                    hasta: this.hasta,
                    pagado: true,
                    tipo_gasto: this.tipoGastoSeleccionado || null,
                }).then((response) => {
                    if (response.data && response.data.estado) {
                        this.actualizarEstadoPagadoLocal(
                            this.eventosVisiblesIds,
                            !!response.data.pagado_historial,
                            response.data.pagado_historial_at || null,
                            this.tipoGastoSeleccionado || null
                        );
                        Swal.fire({
                            icon: 'success',
                            title: response.data.mensaje || 'Comprobantes marcados como rendidos',
                            text: `Actualizados: ${response.data.cantidad || 0}`,
                            showConfirmButton: false,
                            timer: 2800,
                        });
                        this.mostrarmes({ preservePage: true });
                        return;
                    }

                    throw new Error((response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudieron marcar los comprobantes');
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: error?.response?.data?.mensaje || error?.message || 'No se pudieron marcar los comprobantes visibles',
                        showConfirmButton: false,
                        timer: 3200,
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
            });
        },
        async generarPDFtodos() {
            return this.runDownload('gastos_todos_pdf', async () => {
                this.isLoading = true;
                try {
                    const doc = new jsPDF();
                    doc.setFont("helvetica", "bold");
                    let primeraPagina = true;
                    for (const item of this.gastosFiltradosConEvento) {
                        const evento = item.evento;
                        const gasto = item.gasto;
                            if (!primeraPagina) {
                                doc.addPage();
                            }
                            primeraPagina = false;
                            doc.setFontSize(12);
                            doc.text("Evento: " + evento.codigo, 20, 16);
                            doc.text("Fecha: " + gasto.fecha, 20, 26);
                            doc.text("Monto: " + gasto.monto, 20, 36);
                            if (gasto.imagen_url) {
                                try {
                                    const extension = gasto.imagen_url.split('.').pop().toLowerCase();

                                    if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                                        const base64 = await this.convertirImagenABase64(gasto.imagen_url);
                                        doc.addImage(base64, "PNG", 20, 48, 100, 100);
                                    } else if (extension === "pdf") {
                                        const response = await fetch(gasto.imagen_url);
                                        const blob = await response.blob();
                                        const pdfUrl = URL.createObjectURL(blob);

                                        const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                                        const page = await pdfDoc.getPage(1);
                                        const viewport = page.getViewport({ scale: 1 });

                                        const canvas = document.createElement("canvas");
                                        const context = canvas.getContext("2d");
                                        canvas.width = viewport.width;
                                        canvas.height = viewport.height;

                                        await page.render({ canvasContext: context, viewport }).promise;

                                        const pdfImage = canvas.toDataURL("image/png");
                                        doc.addImage(pdfImage, "PNG", 20, 48, 150, 200);
                                    }
                                } catch (error) {
                                    console.error("Error al cargar la imagen o PDF:", error);
                                }
                            }
                    }
                    doc.save("documento.pdf");
                    for (const item of this.gastosFiltradosConEvento) {
                        try {
                            await axios.get('/api/descarga_gasto/' + item.gasto.id);
                        } catch (error) {
                            console.error("Error al registrar la descarga:", error);
                        }
                    }
                    this.mostrarmes();
                } finally {
                    this.isLoading = false;
                }
            }, {
                message: 'Se estan generando los comprobantes. Esto puede tardar unos segundos.'
            });
        },
        obtenerGastosPorTipoSeleccionado() {
            if (!this.tipoGastoDescargaSeleccionado) {
                return [];
            }

            const gastosPorTipo = [];
            for (const evento of this.filteredDataBase) {
                for (const gasto of (evento.gastos || [])) {
                    if (gasto.tipo_gasto === this.tipoGastoDescargaSeleccionado) {
                        gastosPorTipo.push({ evento, gasto });
                    }
                }
            }

            return gastosPorTipo;
        },
        async generarPDFporTipo() {
            if (!this.tipoGastoDescargaSeleccionado) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Seleccione un tipo de gasto',
                    showConfirmButton: false,
                    timer: 2500
                });
                return;
            }
            return this.runDownload('gastos_pdf_tipo', async () => {
                this.isLoading = true;
                try {
                    const gastosPorTipo = this.obtenerGastosPorTipoSeleccionado();

                    if (!gastosPorTipo.length) {
                        Swal.fire({
                            icon: 'info',
                            title: 'No hay comprobantes para el tipo seleccionado',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        return;
                    }

                    const doc = new jsPDF();
                    doc.setFont("helvetica", "bold");
                    let primeraPagina = true;

                    for (const item of gastosPorTipo) {
                        const evento = item.evento;
                        const gasto = item.gasto;

                        if (!primeraPagina) {
                            doc.addPage();
                        }
                        primeraPagina = false;

                        doc.setFontSize(12);
                        doc.text("Evento: " + evento.codigo, 20, 16);
                        doc.text("Tipo: " + gasto.tipo_gasto, 20, 26);
                        doc.text("Fecha: " + gasto.fecha, 20, 36);
                        doc.text("Monto: " + gasto.monto, 20, 46);

                        if (gasto.imagen_url) {
                            try {
                                const extension = gasto.imagen_url.split('.').pop().toLowerCase();

                                if (extension === "png" || extension === "jpg" || extension === "jpeg") {
                                    const base64 = await this.convertirImagenABase64(gasto.imagen_url);
                                    doc.addImage(base64, "PNG", 20, 58, 100, 100);
                                } else if (extension === "pdf") {
                                    const response = await fetch(gasto.imagen_url);
                                    const blob = await response.blob();
                                    const pdfUrl = URL.createObjectURL(blob);

                                    const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
                                    const page = await pdfDoc.getPage(1);
                                    const viewport = page.getViewport({ scale: 1 });

                                    const canvas = document.createElement("canvas");
                                    const context = canvas.getContext("2d");
                                    canvas.width = viewport.width;
                                    canvas.height = viewport.height;

                                    await page.render({ canvasContext: context, viewport }).promise;

                                    const pdfImage = canvas.toDataURL("image/png");
                                    doc.addImage(pdfImage, "PNG", 20, 58, 150, 180);
                                }
                            } catch (error) {
                                console.error("Error al cargar la imagen o PDF:", error);
                            }
                        }
                    }

                    doc.save("documento_" + this.tipoGastoDescargaSeleccionado.replace(/\s+/g, '_') + ".pdf");

                    for (const item of gastosPorTipo) {
                        try {
                            await axios.get('/api/descarga_gasto/' + item.gasto.id);
                        } catch (error) {
                            console.error("Error al registrar la descarga:", error);
                        }
                    }
                    this.mostrarmes();
                } finally {
                    this.isLoading = false;
                }
            }, {
                message: 'Se esta generando el PDF por tipo. Esto puede tardar unos segundos.'
            });
        },
        async generarExcelPorTipo() {
            if (!this.tipoGastoDescargaSeleccionado) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Seleccione un tipo de gasto',
                    showConfirmButton: false,
                    timer: 2500
                });
                return;
            }

            return this.runDownload('gastos_excel_tipo', async () => {
                const gastosPorTipo = this.obtenerGastosPorTipoSeleccionado();

                if (!gastosPorTipo.length) {
                    Swal.fire({
                        icon: 'info',
                        title: 'No hay registros para el tipo seleccionado',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    return;
                }

                const filas = gastosPorTipo.map(({ evento, gasto }) => ({
                    Evento: evento.codigo || '',
                    Colegio: evento.colegio || '',
                    Coordinador: evento.coordinador_evento || '',
                    'Tipo de gasto': gasto.tipo_gasto || '',
                    Fecha: gasto.fecha || '',
                    Monto: gasto.monto || '',
                    Rendido: gasto.pagado_historial ? 'Si' : 'No',
                    'Fecha rendicion': gasto.pagado_historial_at ? this.formatFechaHora(gasto.pagado_historial_at) : '',
                    'Comprobante disponible': gasto.comprobante_disponible ? 'Si' : 'No',
                }));

                const worksheet = XLSX.utils.json_to_sheet(filas);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Gastos');

                const nombreTipo = this.tipoGastoDescargaSeleccionado
                    .toString()
                    .trim()
                    .replace(/[^a-zA-Z0-9]+/g, '_')
                    .replace(/^_+|_+$/g, '') || 'tipo';

                XLSX.writeFile(workbook, `gastos_${nombreTipo}_${this.desde}_${this.hasta}.xlsx`);
            }, {
                message: 'Se esta generando el Excel por tipo. Esto puede tardar unos segundos.'
            });
        },
        convertirImagenABase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const base64 = canvas.toDataURL("image/png");
                    resolve(base64);
                };
                img.onerror = () => reject(new Error("No se pudo cargar la imagen"));
            });
        }
    },
    created(){
        this.obtenerRangoFechas();
        this.mostrarmes(true);
        /*axios.get('/api/get_gastos').then(res=>{
            this.reembolsos=res.data.eventos;
        });*/
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message
            v-if="isInitialLoading"
            title="Cargando historial de gastos"
            subtitle="Estamos trayendo los gastos aprobados del periodo. Esto puede tardar unos segundos."
        />
        <loading-message
            v-if="isLoadingHistorial && !isInitialLoading"
            title="Actualizando historial"
            subtitle="Estamos aplicando los filtros y trayendo los datos. Esto puede tardar unos segundos."
        />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes" :disabled="isLoadingHistorial">
                                    <b-spinner small class="mr-1" v-if="isLoadingHistorial"></b-spinner>
                                    {{ isLoadingHistorial ? 'Cargando...' : 'Ver' }}
                                </b-button>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-4">
                                <b-form-group label="Coordinador">
                                    <multiselect
                                        v-model="coordinadorSeleccionado"
                                        :options="coordinadoresDisponibles"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :show-labels="false"
                                        placeholder="Todos los coordinadores"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                    >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Tipo de gasto">
                                    <b-form-select v-model="tipoGastoSeleccionado" :options="tiposGastoDisponibles"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Estado de rendicion">
                                    <b-form-select v-model="estadoPagoSeleccionado" :options="estadoPagoOptions"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Sede">
                                    <b-form-select v-model="sedeSeleccionada" :options="sedesDisponibles"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Rendicion desde">
                                    <date-picker v-model="fechaRendicionDesde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" placeholder="Sin limite inferior"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Rendicion hasta">
                                    <date-picker v-model="fechaRendicionHasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" placeholder="Sin limite superior"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-8">
                                <b-form-group label="Buscar en resultados (incluye RBD)">
                                    <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Evento, codigo, RBD, coordinador, colegio, sede o tipo..."
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 d-flex align-items-end justify-content-md-end">
                                <b-button variant="outline-secondary" class="mb-3" @click="limpiarFiltros">Limpiar filtros</b-button>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-md-3 col-sm-6 mb-3">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Rango actual</small>
                                    <strong>{{ rangoFechasLabel }}</strong>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-6 mb-3">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Eventos visibles</small>
                                    <strong>{{ filteredData.length }}</strong>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-6 mb-3">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Comprobantes visibles</small>
                                    <strong>{{ comprobantesFiltradosCount }}</strong>
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-6 mb-3">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Pendientes de rendicion</small>
                                    <strong>{{ totalPendientesPago }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12 mb-3">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Monto visible</small>
                                    <strong>$ {{ formatMonto(montoTotalFiltrado) }}</strong>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-12 pb-4">
                <div class="d-flex flex-wrap justify-content-end">
                    <b-button v-if="puedeGestionarPagos" variant="outline-success" class="mr-2 mb-2" @click="marcarPagadosVisibles" :disabled="!totalPendientesPago || isLoading">
                        Marcar rendidos visibles
                    </b-button>
                    <b-button variant="outline-primary" class="mr-2 mb-2" @click="mostrarDescargaPorTipo = !mostrarDescargaPorTipo" :disabled="anyDownloadInProgress">
                        {{ mostrarDescargaPorTipo ? 'Ocultar descarga por tipo' : 'Descargar por tipo' }}
                    </b-button>
                    <b-button variant="primary" class="mb-2" v-b-popover.hover="'Se descargan solo los comprobantes visibles según el filtro actual'" title="Descarga de comprobantes" @click="generarPDFtodos" :disabled="anyDownloadInProgress || !comprobantesFiltradosCount">
                    <b-spinner small class="mr-2" v-if="isDownloadLoading('gastos_todos_pdf')"></b-spinner>
                        {{ getDownloadLabel('gastos_todos_pdf', 'Descargar PDF filtrado', anyDownloadInProgress ? 'Descarga en progreso...' : 'Generando PDF...') }}
                    </b-button>
                </div>
            </div>
            <div class="col-md-12 pb-3" v-if="mostrarDescargaPorTipo">
                <div class="row justify-content-end">
                    <div class="col-md-5 col-lg-4">
                        <div class="border rounded bg-light p-3">
                            <b-form-group label="Tipo de gasto" class="mb-3">
                                <b-form-select v-model="tipoGastoDescargaSeleccionado" :options="tiposGastoDisponibles"></b-form-select>
                            </b-form-group>
                            <div class="descarga-tipo-acciones">
                                <b-button variant="primary" class="descarga-tipo-acciones__boton" @click="generarPDFporTipo" :disabled="anyDownloadInProgress">
                                    <b-spinner small class="mr-2" v-if="isDownloadLoading('gastos_pdf_tipo')"></b-spinner>
                                    {{ getDownloadLabel('gastos_pdf_tipo', 'Descargar PDF', anyDownloadInProgress ? 'Descarga en progreso...' : 'Generando PDF...') }}
                                </b-button>
                                <b-button variant="outline-primary" class="descarga-tipo-acciones__boton" @click="generarExcelPorTipo" :disabled="anyDownloadInProgress">
                                    <b-spinner small class="mr-2" v-if="isDownloadLoading('gastos_excel_tipo')"></b-spinner>
                                    {{ getDownloadLabel('gastos_excel_tipo', 'Descargar Excel', anyDownloadInProgress ? 'Descarga en progreso...' : 'Generando Excel...') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="filteredData.length>0">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <div class="d-inline-flex align-items-center flex-nowrap">
                                        <span>Mostrar</span>
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="w-auto mx-2"></b-form-select>
                                        <span>eventos de {{ rows }} registros visibles</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right text-muted pt-2">
                                    Mostrando {{ comprobantesFiltradosCount }} comprobante(s) en {{ filteredData.length }} evento(s)
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover tabla-historial-gastos">
                                <thead>
                                    <tr>
                                        <th class="columna-numero">Nº</th>
                                        <th class="columna-evento">Evento</th>
                                        <th class="columna-rbd">RBD</th>
                                        <th class="columna-colegio">Colegio</th>
                                        <th class="columna-coordinador">Coordinador</th>
                                        <th class="columna-comprobantes">Comprobantes</th>
                                        <th class="columna-total">Monto total</th>
                                        <th class="columna-pagado">Rendido</th>
                                        <th class="columna-fecha">Fecha rendicion</th>
                                        <th class="columna-accion">Acción</th>
                                    </tr>
                                </thead>
                                <tbody v-for="(item, index) in paginatedData" :key="item.id">
                                    <tr class="evento-resumen-row">
                                        <td class="columna-numero">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
                                        <td class="columna-evento">{{ item.codigo}}</td>
                                        <td class="columna-rbd">{{ item.rbd_colegio || '-' }}</td>
                                        <td class="columna-colegio">
                                            <span class="texto-resumido" :title="tituloColegio(item.colegio)">{{ resumenColegio(item.colegio) }}</span>
                                        </td>
                                        <td class="columna-coordinador">{{ item.coordinador_evento }}</td>
                                        <td class="columna-comprobantes">{{ item.total_comprobantes || 0 }}</td>
                                        <td class="columna-total">{{ formatMonto(item.monto_total) }}</td>
                                        <td class="columna-pagado">
                                            <div class="estado-rendicion-control">
                                                <b-form-checkbox
                                                    v-if="puedeGestionarPagos"
                                                    switch
                                                    :checked="!!item.pagado_historial"
                                                    :disabled="!item.permite_marcar_pagado || isUpdatingPagoEvento(item.id)"
                                                    @change="marcarPagadoEvento(item, $event)"
                                                >
                                                    {{ item.pagado_historial ? 'Sí' : 'No' }}
                                                </b-form-checkbox>
                                                <span v-else>{{ item.pagado_historial ? 'Sí' : 'No' }}</span>
                                                <span v-if="isUpdatingPagoEvento(item.id)" class="estado-rendicion-loading text-muted">
                                                    <b-spinner small class="mr-1"></b-spinner>
                                                    Actualizando...
                                                </span>
                                            </div>
                                        </td>
                                        <td class="columna-fecha">
                                            <span v-if="isUpdatingPagoEvento(item.id)" class="text-muted d-inline-flex align-items-center">
                                                <b-spinner small class="mr-1"></b-spinner>
                                                Actualizando fecha...
                                            </span>
                                            <span v-else>{{ formatFechaHora(item.pagado_historial_at) || '-' }}</span>
                                        </td>
                                        <td class="columna-accion">
                                            <b-button v-b-toggle="'accordion-'+item.id" variant="secondary" @click="ver_mas(item)">{{ labelVerMas(item) }}</b-button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="10" class="p-0 border-0">
                                            <b-collapse
                                                :id="'accordion-'+item.id"
                                                accordion="my-accordion"
                                                role="tabpanel"
                                                @shown="onEventoExpanded(item.id)"
                                                @hidden="onEventoCollapsed(item.id)"
                                            >
                                                <div class="p-3 border-top comprobantes-panel">
                                                    <div class="comprobantes-panel__header">
                                                        <div>
                                                            <div class="comprobantes-panel__eyebrow">Detalle del evento</div>
                                                            <h6 class="mb-1">Comprobantes de {{ item.codigo }}</h6>
                                                            <small :title="tituloColegio(item.colegio)">{{ tituloColegio(item.colegio) }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="table-responsive mb-0">
                                                        <table class="table table-sm mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 5%;">Nº</th>
                                                                    <th style="width: 8%;">Tipo Gasto</th>
                                                                    <th style="width: 10%;">Monto</th>
                                                                    <th style="width: 10%;">Fecha descarga</th>
                                                                    <th style="width: 20%;">Comprobante</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                    <td>{{ index2+1 }}</td>
                                                                    <td>{{ item2.tipo_gasto}}</td>
                                                                    <td>{{ item2.monto }}</td>
                                                                    <td>{{ item2.fecha_descarga==null?'':formatFecha(item2.fecha_descarga) }}</td>
                                                                    <td>
                                                                        <b-button v-if="item2.comprobante_disponible" variant="primary" @click="ver_comprobante(item2)" size="sm">Ver</b-button>
                                                                        <span v-else class="badge badge-secondary" title="El archivo fue subido con el sistema anterior y ya no está disponible en el servidor">Sin archivo</span>
                                                                        <b-button variant="primary" @click="generarPDF(item,item2)" size="sm" v-if="item2.fecha_descarga==null" :disabled="anyDownloadInProgress">
                                                                            <b-spinner small class="mr-1" v-if="isDownloadLoading('gasto_' + item2.id)"></b-spinner>
                                                                            {{ getDownloadLabel('gasto_' + item2.id, 'Descarga', anyDownloadInProgress ? 'Descarga en progreso...' : 'Generando...') }}
                                                                        </b-button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <div v-if="!archivoDisponible" class="alert alert-warning mb-0">
                                {{ archivoMensaje }}
                            </div>
                            <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-center">No hay gastos agregados en este periodo</h4>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
.tabla-historial-gastos {
    width: 100%;
    table-layout: auto;
}

.tabla-historial-gastos th,
.tabla-historial-gastos td {
    vertical-align: top;
}

.tabla-historial-gastos .columna-numero {
    width: 5%;
}

.tabla-historial-gastos .columna-evento {
    width: 10%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-rbd {
    width: 8%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-colegio {
    width: 14%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-coordinador {
    width: 14%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-comprobantes {
    width: 10%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-total {
    width: 12%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-pagado {
    width: 8%;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-fecha {
    width: 11%;
    white-space: nowrap;
}

.estado-rendicion-control {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 1.75rem;
}

.estado-rendicion-loading {
    display: inline-flex;
    align-items: center;
    font-size: 0.8rem;
}

.descarga-tipo-acciones {
    display: flex;
    gap: 0.75rem;
}

.descarga-tipo-acciones__boton {
    flex: 1 1 0;
    white-space: nowrap;
}

.tabla-historial-gastos .columna-accion {
    width: 10%;
    white-space: nowrap;
}

.evento-resumen-row {
    background: #fffdf8;
}

.texto-resumido {
    display: inline-block;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
}

.comprobantes-panel {
    background: linear-gradient(180deg, #fffaf2 0%, #ffffff 100%);
    border-left: 4px solid #c87838;
}

.comprobantes-panel__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding-bottom: 0.9rem;
    margin-bottom: 0.9rem;
    border-bottom: 1px solid #eadbc8;
}

.comprobantes-panel__eyebrow {
    font-size: 0.72rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9b6a3f;
    margin-bottom: 0.25rem;
}

@media (max-width: 767px) {
    .tabla-historial-gastos {
        min-width: 1320px;
    }

    .texto-resumido {
        max-width: 220px;
    }
}
</style>
